import { defineStore } from 'pinia';

export interface Plan {
  code: string;
  name: string;
}

export interface PlansStore {
  team?: Plan[];
  personal?: Plan[];
}

export const usePlansStore = defineStore('plansStore', {
  state: () =>
    ({
      team: undefined,
      personal: undefined,
    }) as PlansStore,

  actions: {
    initialize(data: any) {
      this.setTeamPlans(data.team);
      this.setPersonal(data.personal);
    },
    setTeamPlans(team: Plan[]) {
      this.team = team;
    },
    setPersonal(personal: Plan[]) {
      this.personal = personal;
    },
  },
  getters: {
    isTeam: (state: PlansStore) => (planCode: string) => {
      return !!state.team?.find(plan => plan.code === planCode);
    },
    isPersonal: (state: PlansStore) => (planCode: string) => {
      return !!state.personal?.find(plan => plan.code === planCode);
    },
  },
});
